// extracted by mini-css-extract-plugin
export default {"root":"styled-input-fixed__root___LUsPS"};